// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3xJtu","productName":"Table_productName__3oJ2A"};